<template>
  <section :id="pageId" class="swiper-slide swiper-no-swiping step-layout-wrapper">
    <div class="step-title" v-if="title || $slots.title">
      <slot name="title">
        <h3 v-if="title">{{ title }}</h3>
      </slot>
    </div>
    <div :id="contentId || null" :class="bodyClass">
      <slot></slot>
    </div>
    <div class="step-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: "StepLayout",
  props: {
    pageId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      default: ""
    },
    contentId: {
      type: String,
      default: ""
    },
    contentClass: {
      type: String,
      default: ""
    }
  },
  computed: {
    bodyClass() {
      return ["step-body", this.contentClass].filter(Boolean);
    }
  }
};
</script>

<style lang="scss" scoped>
.step-layout-wrapper {
  min-height: 100%;
}

.step-title {
  h3 {
    margin-left: 0 !important;
    margin-bottom: 20px;
    font-weight: 600;
    font-size: 19px !important;
  }
}

.step-body {
  min-width: 0;
}

.step-footer {
  padding: 10px 20px 30px;
  background-color: #fff;
  border-top: 1px solid #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/components/StepLayout.vue